import { render, staticRenderFns } from "./importConfigMaster.vue?vue&type=template&id=37122d7a&"
import script from "./importConfigMaster.vue?vue&type=script&lang=js&"
export * from "./importConfigMaster.vue?vue&type=script&lang=js&"
import style0 from "./importConfigMaster.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports